import { t } from 'i18next';
export const uploadStatusString = (
  isUploading: boolean,
  isValidating: boolean,
  isImporting: boolean,
  validationError: string | null,
  isValidationComplete: boolean,
) => {
  if (isUploading) {
    return t('add_wallet_modal.csv_form.status.uploading');
  }

  if (isValidating) {
    return t('add_wallet_modal.csv_form.status.validating');
  }

  if (isImporting) {
    return t('add_wallet_modal.csv_form.status.importing');
  }

  if (isValidationComplete && !validationError) {
    return t('add_wallet_modal.csv_form.status.validation_complete');
  }

  return '';
};
